const ENUM = {
    PIECE_TYPE : {
        PAWN : "pawn",
        ROOK : "rook",
        KNIGHT : "knight",
        BISHOP : "bishop",
        QUEEN : "queen",
        KING : "king"
    },
    CHESS_COLOR : {
        WHITE : "white",
        BLACK : "black"
    },
    GAME_STATUS : {
        WIN : "win",
        PAT : "pat"
    }
}

export default ENUM;